import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import SmoothScroll from '@/components/layout/SmoothScroll';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import Home from '@/pages/Home';
import ServicesPage from '@/pages/Services';
import AboutPage from '@/pages/About';
import ProjectsPage from '@/pages/Projects';
import ContactPage from '@/pages/Contact';
import AdminLeads from '@/pages/AdminLeads';
import BrandConcept from '@/pages/BrandConcept';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <div className="App min-h-screen bg-[#FAFAF5] text-[#0A0A0A]">
      <div className="grain" aria-hidden />
      {!isAdmin && <Navbar />}
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/brand-concept" element={<BrandConcept />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: '#ffffff', color: '#0A0A0A', border: '1px solid rgba(0,0,0,0.1)', fontFamily: 'Manrope, sans-serif' } }} />
    </div>
  );
}

export default function App() {
  return (
    <SmoothScroll>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </SmoothScroll>
  );
}
